<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-4">
      <button class="btn btn-danger ms-2 mt-4 my-2" @click="retroceder">
        <i class="bi bi-skip-backward"></i>
      </button>
      <div class="border border-1 rounded-3 p-3 mb-2 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-gear-fill display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              ETAPA DE CONTRATOS
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">

              DATOS GENERALES
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <p for="" class="text-danger text-center fw-bold tamaño">
          {{ mensaje }}
        </p>
      </div>

      <div class="col-12">
        <div class="row g-2 mb-3">

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">NOMBRE :</p>
              <label class="ms-1 tamaño" disabled> {{ nombre }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">APELLIDO PATERNO :</p>
              <label class="ms-1 tamaño" disabled> {{ paterno }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">APELLIDO MATERNO :</p>
              <label class="ms-1 tamaño" disabled> {{ materno }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">BANCO HABERES :</p>
              <label class="ms-1 tamaño" disabled> {{ bancoHaberes }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">MONEDA HABERES :</p>

              <label class="ms-1 tamaño" disabled> {{ monHaberes }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">BANCO CTS :</p>
              <label class="ms-1 tamaño" disabled> {{ bancoCts }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">MONEDA CTS :</p>
              <label class="ms-1 tamaño" disabled> {{ monCts }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">SISTEMA PENSIONES :</p>
              <label class="ms-1 tamaño" disabled> {{ sisPensiones }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row g-2">

          <div v-for="escoge in escoger" :key="escoge.id" class="col-12 col-md-6 mb-0">
            <div class="shadow-sm p-3 mb-2 bg-white rounded-3 border">

              <!-- Título con icono -->
              <div class="d-flex align-items-center mb-2">
                <i class="bi bi-folder-fill text-primary fs-4 me-2"></i>
                <span class="fw-bold text-secondary">{{ escoge.parDescripcion }}</span>
              </div>

              <!-- Subida -->
              <div class="input-group">
                <label class="input-group-text bg-primary text-white">
                  <i class="bi bi-paperclip"></i>
                </label>

                <input type="file" class="form-control tamaño" multiple required @change="onFileSelected" />

                <button class="btn btn-success" type="button" @click="onUpload($event)" :value="escoge.parCorrelativo">
                  <i class="bi bi-cloud-upload-fill me-1"></i> Subir
                </button>
              </div>
            </div>
          </div>

          <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
            <div class="mx-2 mt-3">
              <div class="card shadow-sm mb-3 border-0 rounded-3">
                <div class="card-body d-flex align-items-center">
                  <button disabled :class="{
                    'btn btn-success mt-3': solPosEstado,
                    'btn btn-warning mt-3': !solPosEstado
                  }">
                    <i class="bi bi-vector-pen fs-4"></i>
                  </button>



                  <p class="ms-3 mt-2 fw-semibold text-secondary tamaño flex-grow-1">1.Opción para dar conformidad de la
                    firma de contrato</p>
                </div>
              </div>

              <div class="card shadow-sm mb-3 border-0 rounded-3">
                <div class="card-body d-flex align-items-center">

                  <!-- ÍCONO O CÓDIGO -->
                  <template v-if="codTrabajador.length <= 0">
                    <button disabled class="btn btn-warning mt-3">
                      <i class="bi bi-person-vcard fs-4"></i>
                    </button>
                  </template>

                  <template v-else>
                    <button disabled class="btn btn-success ">{{ codTrabajador }}</button>
                  </template>

                  <!-- DESCRIPCIÓN A LA DERECHA -->
                  <p class="ms-3 mt-2 fw-semibold text-secondary tamaño flex-grow-1">
                    2.Opción para generar la migración de la información al aplicativo de Nóminas y ERP
                  </p>

                </div>
              </div>
              <div v-if="permisoVisualizador != 18" class="table-responsive mx-2 mt-3">
                <div class="d-flex justify-content-end mx-4 ">
                  <label for="" class="mt-4 tamaño"> Buscar:</label>
                  <input class="form-control form-control-lg w-25 mx-4 mt-3 tamaño" type="text"
                    placeholder="Buscar por tipo de documento..." aria-label=".form-control-lg example"
                    v-model="filterField" />
                </div>
                <table class="table table-bordered mt-3">
                  <thead>
                    <tr class="bg-solimano text-white text-center tamaño">
                      <th>ID</th>
                      <th scope="col">TIPO DOCUMENTO</th>
                      <th scope="col">DOCUMENTO</th>
                      <th>RESPONSABLE DE CARGA</th>
                      <th>AUDITORIA</th>

                      <th v-if="permisoVisualizador == 6">ELIMINAR</th>
                    </tr>
                  </thead>
                  <tbody v-for="(documentos, index) in documento.slice(
                    NUM_RESULTS - 6,
                    NUM_RESULTS
                  )" :key="index.id">
                    <tr class="tamaño">
                      <td class="text-center">

                        {{ documentos.idDocumento }}
                      </td>

                      <!-- TIPO DOCUMENTO -->
                      <td class="text-center">
                        <i class="bi bi-folder2-open text-warning me-1"></i>
                        {{ documentos.nomTipoDocumento }}
                      </td>
                      <td class="text-center">
                        <a :href="url +
                          documentos.docAdjunto.slice(73, documentos.docAdjunto.length)
                          " target="_blank" class="btn btn-ligth">
                          <i class="bi bi-file-earmark-pdf text-danger fs-4"></i>
                        </a>
                      </td>
                      <td class="text-center">
                        <i class="bi bi-gear-wide-connected text-info me-1"></i>
                        {{ documentos.desProceso }}
                      </td>

                      <!-- AUDITORÍA -->
                      <td class="text-center">
                        <i class="bi bi-person-badge-fill text-success me-1"></i>
                        {{ documentos.audCrea }}
                      </td>
                      <td v-if="permisoVisualizador == 6" class="text-center">
                        <div class="mx-2">
                          <button class="btn btn-danger" @click="Eliminar(documentos.idDocumento)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                              class="bi bi-trash3 text-white" viewBox="0 0 16 16">
                              <path
                                d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>

            <!-- <div v-if="permisoVisualizador != 18" class="d-flex mt-3">
              <button class="btn btn-dark mx-4" @click="retroceso" :disabled="noRetroceder">
                <span aria-hidden="true">{{ retrocede }}</span>
              </button>
              <button class="btn btn-primary" :disabled="true">
                {{ pag }}
              </button>
              <button class="btn btn-dark mx-4" @click="aumentar" :disabled="noAvanzar">
                <span aria-hidden="true">{{ avanza }}</span>
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>



  </div>


</template>

<script>
// import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "SolimanologEstadoContrato",

  data() {
    return {
      retrocede: "<<",
      avanza: ">>",
      filterField: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Contratos/",
      nombre: "",
      paterno: "",
      materno: "",
      bancoHaberes: "",
      bancoCts: "",
      monHaberes: "",
      monCts: "",
      sisPensiones: "",
      idParametro: "",
      parCorrelativo: "",
      parDescripcion: "",
      tipoDoc: "",
      idUsuario: "",
      escoger: [],
      selectedFile: "",
      documento: [],
      noAvanzar: false,
      noRetroceder: false,
      cerrarTable1: true,
      cerrarTable2: false,
      NUM_RESULTS: 6,
      pag: 1,
      cerrarPorSeguimiento: true,
      permisoVisualizador: null,
      codTrabajador: "",
      solPosEstado: "",
      mensaje: null,

    };
  },

  mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    console.log(this.$route.params.ContraCon);
    this.axios
      .get("Contrato/ObtenerDatosContrato/" + this.$route.params.ContraCon)
      .then((r) => {
        this.nombre = r.data[0].posNombre;
        this.paterno = r.data[0].posApellidoPaterno;
        this.materno = r.data[0].posApellidoMaterno;
        this.bancoHaberes = r.data[0].bancoHaberes;
        this.monHaberes = r.data[0].monHaberes;
        this.bancoCts = r.data[0].bancoCts;
        this.monCts = r.data[0].monCts;
        this.sisPensiones = r.data[0].sisPensiones;
        this.codTrabajador = r.data[0].codTrabajador;
        this.solPosEstado = r.data[0].solPosEstado;
      });

    let autUser = localStorage.getItem("userId");
    this.idUsuario = autUser;

    this.axios
      .get(
        `Contrato/TipoDocxContrato?idSolxPostulante=${this.$route.params.ContraCon}&idUsuario=${autUser}`
      )
      .then((r) => {
        console.log(r.data);
        this.escoger = r.data;
      });
  },

  created() {
    this.getAttributes();
    this.cambiarEstadoNavbar();
    this.mensajeContrato();


  },

  computed: {
    ...mapGetters("parametros", [
      "EstadoCiviles",
      "Genero",
      "Arreglar",
      "DepartamentoDistrito",
      "NacionEstado",
      "PaisEstado",
    ]),
    ...mapGetters("users", ["Items", "Permisos"]),
  },

  methods: {

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    async getAttributes() {
      let doc = await this.axios.get(
        `Contrato/ListarDocContrato/${this.$route.params.ContraCon}`
      );
      console.log(doc.data);
      this.documento = doc.data;
    },

    mensajeContrato() {
      let autUser = localStorage.getItem("userId");
      this.axios
        .get(
          `Contrato/ValidarContratos?idSolxPostulante=${this.$route.params.ContraCon}&idUsuario=${autUser}`
        )
        .then((r) => {
          this.mensaje = r.data;
          console.log(r)
        });
    },

    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);
    },

    onUpload(event) {
      this.tipoDoc = event.target.value;

      const fd = new FormData();
      fd.append("idSolxPostulante", this.$route.params.ContraCon);
      fd.append("tipoDoc", this.tipoDoc);
      fd.append("idUsuario", this.idUsuario);
      fd.append("ArchivoCont", this.selectedFile);

      this.axios.post("Contrato/InsertarContrato", fd).then((r) => {
        console.log(r.data);
        if (r.data == true) {
          let timerInterval;
          Swal.fire({
            title: "¡Espere un momento, no cerrar la pantalla!",
            html: "<strong>Cargando archivo <b></b> ...</strong>",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                b.textContent = Swal.getTimerLeft();
              }, 450);
            },
            willClose: () => {
              clearInterval(timerInterval);
            },
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              this.getAttributes();
            }
          });
        }
      });
    },

    // Eliminar(id) {
    //   Swal.fire({
    //     title: "Deseas Eliminar",
    //     // text: "You won't be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Si, Elimar!",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       Swal.fire("Eliminado!", "con exito.", "success");
    //       this.axios.delete("Documentos/Eliminar/" + id).then((r) => {
    //         console.log(r.data);
    //         this.getAttributes();
    //       });
    //     }
    //   });
    // },

    retroceder() {
      window.history.back();
    },
    retroceso() {
      if (this.NUM_RESULTS === 6) {
        // this.retro = false;
        //  this.avanzar = true;
        this.noRetroceder = true;
      } else {
        // this.retro = true;
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
        //  this.avanzar = true
      }
    },

    aumentar() {
      this.NUM_RESULTS += 6;
      this.pag += 1;
      if (this.NUM_RESULTS > 6) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.documento.length) {
        this.noAvanzar = true;
      }
      // console.log(this.NUM_RESULTS);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

.color {
  font-size: 0.75rem;
  font-weight: 700;
  color: #002c5d;
}

.titulo2 {
  color: #0080c8;
  text-decoration: underline;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.tamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #0080c8;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamañofiltrado {
  font-size: 0.65rem;
}
</style>
